module.exports = __webpack_public_path__ + "img/vnptca.7ff10faa.svg";